import type { Timestamp } from 'firebase/firestore'

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 31_536_000_000],
  ['month', 2_592_000_000],
  ['week', 604_800_000],
  ['day', 86_400_000],
  ['hour', 3_600_000],
  ['minute', 60_000],
]

const rtf = new Intl.RelativeTimeFormat('en-GB', { numeric: 'auto' })

/** "3 days ago". Returns "just now" under a minute, and "" for a missing value. */
export function relativeTime(ts: Timestamp | null | undefined): string {
  const ms = ts?.toMillis?.()
  if (!ms) return ''
  const delta = ms - Date.now()
  for (const [unit, size] of UNITS) {
    if (Math.abs(delta) >= size) return rtf.format(Math.round(delta / size), unit)
  }
  return 'just now'
}
